<template>
  <div>
    <Header />
    <div class="exam_tit">
      <ul>
        <li><router-link to="/curExam">在线考试</router-link></li>
        <li><router-link to="/scoreQuery">成绩查询</router-link></li>
        <li><router-link to="/profile">个人资料</router-link></li>
        <!-- <li><router-link to="/checkVideo2">检测摄像头</router-link></li> -->
      </ul>
    </div>
    <div class="exam_content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
// import CurExam from "@/views/CurExam";
// import ScoreQuery from "@/views/ScoreQuery";
// import Profile from "@/views/Profile";

export default {
  name: "ExamIndex",
  components: {
    Header
  }
};
</script>

<style scoped></style>
